import { createAsyncThunk } from '@reduxjs/toolkit'
import {
  ContractInformation,
  getContractInformation,
} from '../../../api/v1/information'
import { SymbolName } from '../../../types'

export const getContractInformationAction = createAsyncThunk<
  ContractInformation,
  { symbolName: SymbolName }
>('market/getContractInformationAction', async ({ symbolName }) => {
  const { data } = await getContractInformation(symbolName)
  return data
})
